// 1. Imports
import { Container, Stack } from "@mui/material";
import { Page } from "../../../components";
import HeaderBreadcrumbs from "../../../components/header-breadcrumbs";
import { NewMessageComposeComponent } from "../../../components/message-center/v2/send-a-message/new-message-compose-component";

// 2. Component Def
export const NewMessageComposeScreen = () => {
    return (
        <Page title="POM Safe - Compose Message">
            <Container maxWidth={false}>
                <Stack direction="row" alignItems="center" justifyContent="space-between">
                    <HeaderBreadcrumbs 
                        heading="New message"
                        links={[
                            { name: 'Message Center', href: '/messages' },
                            { name: 'Select Recipients', href: '/messages/new/recipients' },
                            { name: 'Compose Message', href: '/messages/new/compose' },
                        ]}
                        activeLast={false}
                    />
                </Stack>

                <NewMessageComposeComponent />
            </Container>
        </Page>
    )
}